import React, {useState} from "react";
import {
    Box,
    Typography,
    Grid,
    Paper,
    Container,
    useTheme,
    useMediaQuery,
    Divider,
} from "@mui/material";
import KazakhstanMap from "../Map";
import {kazakhstanRegions} from "../../../model/regions";

const keyIndicators = [
    { title: "8,2 трлн тг", subtitle: "Общий объем валовой продукции сельского хозяйства" },
    { title: "16,6 млн тонн", subtitle: "Урожай зерновых культур" },
    { title: "2,1 млн тонн", subtitle: "Урожай масличных культур" },
    { title: "$2,7 млрд", subtitle: "Экспорт переработанной продукции АПК (+14.8% к 2023 году)" },
];

const regions = [
    {
        name: "Северо-Казахстанская область",
        info: "Более 27% ВРП региона обеспечивается АПК",
    },
    {
        name: "Акмолинская и Костанайская области",
        info: "Основные регионы по производству зерновых культур",
    },
    {
        name: "Туркестанская область",
        info: "Лидер по тепличному хозяйству и садоводству",
    },
];

const investments = [
    "Государственная поддержка — в 2023 году финансирование субъектов АПК составило не менее 471 млрд тенге",
    "Развитие перерабатывающей промышленности: планируется увеличение доли переработанной продукции до 45% в экспорте АПК",
];

const AgroIndustryPage: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));


    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
    const [hoveredRegion, setHoveredRegion] = useState<string | null>(null);


    const handleRegionClick = (region: any) => {
        setSelectedRegion(region.name);
        console.log('Выбран регион:', region);
    };

    const handleRegionHover = (region: any) => {
        setHoveredRegion(region ? region.name : null);
    };
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Агропромышленный комплекс РК
            </Typography>

            <Typography variant="body1" sx={{ mb: 4 }}>
                АПК — ключевой сектор экономики, который обеспечивает продовольственную безопасность и долю экспорта.
            </Typography>

            <Paper elevation={3} sx={{ p: 3, mb: 5 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Ключевые показатели (на 2024 год)
                </Typography>

                <Grid container spacing={2}>
                    {keyIndicators.map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Box>
                                <Typography variant="h5" fontWeight={700}>
                                    {item.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {item.subtitle}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            <Paper elevation={3} sx={{ p: 3, mb: 5 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Региональная статистика
                </Typography>

                <Grid container spacing={2}>
                    {regions.map((region, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Typography variant="subtitle1" fontWeight={600}>
                                {region.name}
                            </Typography>
                            <Typography variant="body2">{region.info}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            <Paper elevation={3} sx={{ p: 3, mb: 5 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Инвестиционные возможности
                </Typography>

                <ul>
                    {investments.map((text, index) => (
                        <li key={index}>
                            <Typography variant="body2">{text}</Typography>
                        </li>
                    ))}
                </ul>
            </Paper>

            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Карта регионов АПК
                </Typography>
                <Box
                    sx={{
                        mt: 2,
                        width: "100%",
                        backgroundColor: "#e0f7fa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#00796b",
                        fontWeight: 500,
                    }}
                >
                    <KazakhstanMap
                        regions={kazakhstanRegions}
                        onRegionClick={handleRegionClick}
                        onRegionHover={handleRegionHover}
                        defaultFill="#5764f7"
                        hoverFill="#4254f5"
                        activeFill="#3244d0"
                    />

                </Box>
            </Paper>
        </Container>
    );
};

export default AgroIndustryPage;
